export const enAuthLocale = {
  welcome_title: 'Welcome to $t(main:app_name)',
  parent_sign_up_title: 'Parent/Guardian Sign Up',
  parent_sign_up_description:
    "Welcome to $t(main:app_name)! Please sign up with your name, email, and password to create an account and start your child's reading journey.",

  parent_sign_in_title: 'Parent/Guardian Sign In',
  parent_sign_in_description:
    "Welcome back to $t(main:app_name)! Please sign in with your email and password to access your account and continue your child's reading journey.",

  sign_up_button: 'Sign Up',

  sign_up_agreement:
    'By signing up, you agree to $t(main:app_name_possessive) <LinkTos>Terms of Service</LinkTos> and <LinkPrivacy>Privacy Policy.</LinkPrivacy>',

  field_name: 'Name',
  field_name_hint: '',
  field_name_placeholder: 'Enter name...',

  field_email: 'Email Address',
  field_email_placeholder: 'Enter email...',

  field_password: 'Password',
  field_password_placeholder: 'Enter password...',

  field_remember_me: 'Remember Me',

  already_have_account: 'Already have an account? <Link>Sign In</Link>',
  no_account: "Don't have an account? <Link>Sign Up</Link>",

  sign_up_failed: 'Unable to create account. Please try again or contact support@learnwith.ai if the problem persists.',

  sign_in_button: 'Sign In',
  sign_in_failed: 'Failed to Sign In',

  sign_out_button: 'Sign Out',

  auth_token_failed: 'Authentication using the token failed.',
  auth_token_expired: 'Your session has expired. Please Sign In again.',

  forgot_password: 'Forgot Password?',
  forgot_password_title: 'Reset Password',
  reset_password_button: 'Reset Password',
  forgot_password_description: "We'll email you a code to reset your password",
  send_code: 'Send Code',
  resend_code: 'Resend Code',
  resend_code_in_seconds: 'Resend Code ({{seconds}}s)',
  back_to_sign_in: 'Back to Sign In',
  reset_code_sent: 'Reset code has been sent to your email',
  reset_code_send_failed: 'Failed to send reset code',
  user_not_found: 'No account found with this email address',

  verify_code_title: 'Reset Password',
  verify_code_description: 'Enter the 6-digit code that we sent to {{email}}',
  verify_code_button: 'Reset',
  field_verification_code_placeholder: 'Enter 6-digit code',
  field_verification_code_required: 'Verification code is required',
  field_verification_code_length: 'Verification code must be 6 digits',
  invalid_verification_code: 'Invalid verification code',

  reset_password_title: 'Reset Password',
  reset_password_description: 'Set your new password',
  reset_password_failed: 'Failed to reset password',

  signed_up_user_exist:
    "An account with this email already exists. Please sign in with your password or click 'Forgot password?' to reset it.",
};
